import { render, staticRenderFns } from "./DeleteQuiz.vue?vue&type=template&id=99b92d82&"
import script from "./DeleteQuiz.vue?vue&type=script&lang=js&"
export * from "./DeleteQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports